import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Flex, Button, Box } from "ui-components";
import OrderDetailsCard from "components/OrderDetailsCard";
import OrderStepsCard from "components/OrderStepsCard";
import OrderActionsCard from "components/OrderActionsCard";
import { gotoUrl } from "utils/helpers";
import { getButtonColorVariant } from "ui-components/theme";

const GuestOrder = props => {
  const { manageAnotherOrder, buttonTheme } = props;

  return (
    <Box variant="main" padding="2rem">
      <OrderDetailsCard {...props} />
      <OrderStepsCard {...props} />
      <OrderActionsCard {...props} />

      <Flex flexDirection="column" alignItems="center">
        <Button
          data-testid={"manage-another-order-button"}
          my={1}
          width={[1, 0.8, 0.6]}
          sx={getButtonColorVariant(buttonTheme)}
          onClick={manageAnotherOrder}
        >
          <FormattedMessage id="manage_order_manage_another_order" />
        </Button>

        <Button
          data-testid={"buy-new-plan-button"}
          my={1}
          sx={getButtonColorVariant(buttonTheme)}
          width={[1, 0.8, 0.6]}
          onClick={() => {
            gotoUrl("/", false, { reset: true });
          }}
        >
          <FormattedMessage id="manage_order_buy_new_plan" />
        </Button>
      </Flex>
    </Box>
  );
};

export default GuestOrder;
